import { useCallback, useState } from 'react';
import { GetSupportVideo } from '@/apis/auth';

export const useHelpTourVideo = () => {
  const [open, setOpen] = useState(false);
  const [videoSrc, setVideoSrc] = useState('');

  const openTour = useCallback(async () => {
    setVideoSrc('');
    setOpen(true);
    try {
      const res = await GetSupportVideo();
      const videoUrl = res?.data?.data?.data?.video_url;
      if (videoUrl) setVideoSrc(videoUrl);
    } catch (error) {
      console.error('Failed to fetch support video URL:', error);
    }
  }, []);

  const closeTour = useCallback(() => setOpen(false), []);

  return { open, videoSrc, openTour, closeTour };
};

export default useHelpTourVideo;
